import { render } from "./CreatePublicationPost.vue.js?vue&type=template&id=20ee0fd7&scoped=true!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CreatePublicationPost.vue?vue&type=template&id=20ee0fd7&scoped=true"
import script from "./CreatePublicationPost.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CreatePublicationPost.vue?vue&type=script&lang=js"
export * from "./CreatePublicationPost.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CreatePublicationPost.vue?vue&type=script&lang=js"

import "./CreatePublicationPost.vue.scss?vue&type=style&index=0&id=20ee0fd7&scoped=true&lang=scss!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CreatePublicationPost.vue?vue&type=style&index=0&id=20ee0fd7&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20ee0fd7"],['__file',"src/Web/scripts/pages/publication/CreatePublicationPost.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "20ee0fd7"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('20ee0fd7', __exports__)) {
    api.reload('20ee0fd7', __exports__)
  }
  
  module.hot.accept("./CreatePublicationPost.vue.js?vue&type=template&id=20ee0fd7&scoped=true!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CreatePublicationPost.vue?vue&type=template&id=20ee0fd7&scoped=true", () => {
    api.rerender('20ee0fd7', render)
  })

}


export default __exports__